import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";

export const Confirmer = ({ titre, texte, onOk, testId, danger, children }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>
      <button type="button" className={`at-btn ${danger ? "at-btn-danger" : "at-btn-ghost"} w-full`} data-testid={`${testId}-button`}>{children}</button>
    </AlertDialogTrigger>
    <AlertDialogContent className="at-popover max-w-[calc(100vw-2rem)] sm:max-w-md" data-testid={`${testId}-dialog`}>
      <AlertDialogHeader>
        <AlertDialogTitle>{titre}</AlertDialogTitle>
        <AlertDialogDescription>{texte}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter className="gap-2">
        <AlertDialogCancel className="at-btn at-btn-ghost border-0 min-h-[44px]" data-testid={`${testId}-no`}>Non, garder</AlertDialogCancel>
        <AlertDialogAction onClick={onOk} className="at-btn min-h-[44px]" style={{ background: "var(--danger)", color: "var(--accent-ink)" }} data-testid={`${testId}-yes`}>Oui, mettre à la corbeille</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
